import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function Forbidden() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#dce2d7] text-[#1f241d] px-4 py-20">
      <Helmet>
        <title>403 - Adgang nægtet - PR Entreprise & Anlæg ApS</title>
        <meta name="description" content="403 Adgang nægtet. Du har ikke tilladelse til at tilgå denne ressource hos PR Entreprise & Anlæg ApS." />
      </Helmet>

      <div className="max-w-xl text-center space-y-6 bg-white p-10 rounded-none border border-[#cbd3c5] shadow-lg">
        <div className="w-20 h-20 rounded-none bg-[#141f14] text-[#9ecc49] flex items-center justify-center mx-auto text-3xl font-extrabold font-heading border border-[#233323]">
          403
        </div>

        <h1 className="font-heading text-xl sm:text-3xl font-bold text-[#1f241d]">
          Adgang Nægtet
        </h1>

        <p className="text-[#4e564a] text-base leading-relaxed">
          Du har ikke adgang til at se denne side eller ressource. Hvis du mener dette er en fejl, er du velkommen til at kontakte os.
        </p>

        <div className="pt-4 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="bg-[#3d5229] hover:bg-[#2e3f1e] text-white px-6 py-3 rounded-none font-heading font-semibold text-sm transition-colors"
          >
            &larr; Gå til forside
          </Link>
          <Link
            to="/kontakt"
            className="bg-[#9ecc49] hover:bg-[#8ebb3c] text-[#1f241d] px-6 py-3 rounded-none font-heading font-bold uppercase text-xs tracking-wider transition-colors shadow"
          >
            Kontakt support
          </Link>
        </div>
      </div>
    </div>
  );
}
